import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const JigsawTemplateService = {
    /**
     * Check if a template name is duplicated
     * @param {string} name - template name to check
     */
    checkNameDuplicated: async (name) => {
        try {
            const encodedName = encodeURIComponent(name.trim());
            const response = await ApiService.getData(`/v1/puzzle/jigsaw/template/${encodedName}/check-duplicated`);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error checking template name:", error);
            return {
                success: false,
                error: error.message || "Failed to check template name"
            };
        }
    },

    /**
     * Create a new jigsaw template
     * @param {FormData} formData - form data containing template details
     */
    create: async (formData) => {
        try {
            const response = await ApiService.postFormData("/v1/puzzle/jigsaw/template", formData);
            if (response && response.code === "FAILURE") {
                return {
                    success: false,
                    error: response.message || "Create failed"
                };
            }
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error creating template:", error);
            return {
                success: false,
                error: error.message || "Failed to create template"
            };
        }
    }
};

export default JigsawTemplateService;